export default function HeroSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">

      {/* Hero background image — luxury boardroom, no people */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url(https://public.readdy.ai/ai/img_res/edited_9fb11f27edb7d462f5869c016da5db4c_55fc5559.jpg)",
        }}
      />
      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0f2651]/8 to-transparent" />

      {/* Gold top accent line */}
      <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#c9a84c] via-[#c9a84c]/60 to-transparent" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-16 pt-28 pb-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-3 text-[#c9a84c] mb-8">
            <span className="w-8 h-px bg-[#c9a84c] shrink-0" />
            <span className="text-lg font-bold tracking-wide italic [text-shadow:0_2px_8px_rgba(0,0,0,0.6)]">
              A contabilidade com o olhar de quem audita
            </span>
          </div>

          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white leading-[1.15] mb-8 text-left [text-shadow:0_2px_12px_rgba(0,0,0,0.7)]">
            Mais controle.<br />
            Mais clareza.<br />
            <em className="text-[#c9a84c] not-italic">Decisões mais seguras.</em>
          </h1>

          <p className="text-white/85 text-xl md:text-2xl max-w-xl leading-relaxed mb-12 [text-shadow:0_1px_6px_rgba(0,0,0,0.6)]">
            Combinamos experiência contábil, estratégia fiscal e visão analítica para transformar
            números em decisões inteligentes para o seu negócio.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="https://wa.me/5551991003410"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#c9a84c] hover:bg-[#b8943d] text-[#1a2535] font-semibold px-9 py-5 rounded-sm text-base tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-lg" />
              </div>
              Diagnóstico Gratuito
            </a>
            <button
              onClick={() => scrollTo('#sobre')}
              className="inline-flex items-center gap-2 border border-white/50 hover:border-white text-white/85 hover:text-white text-base font-medium px-7 py-5 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap group"
            >
              <span className="w-6 h-px bg-white/50 group-hover:bg-white/90 transition-colors duration-200" />
              Conheça a RCP
            </button>
          </div>

          <div className="mt-10 flex items-center gap-10 border-t border-white/20 pt-7">
            <div className="text-left">
              <div className="text-4xl font-bold text-[#c9a84c]">10+</div>
              <div className="text-white/65 text-base mt-1 leading-tight">Anos de Experiência</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/30 text-2xl" />
      </div>
    </section>
  );
}
